/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableRowOverlayComponent} from './table-row-overlay.component';

@NgModule({
    declarations: [TableRowOverlayComponent],
    imports: [
        CommonModule
    ],
    exports: [TableRowOverlayComponent]
})
export class TableRowOverlayModule {
}
